import { PgDev_SpellCheckTest } from './examples/PgDev_TrieTest/PgDev_SpellCheckTest.js';
import { PgDev_Dialog } from './examples/PgDev_Dialog/PgDev_Dialog.js';
import { PgDev_GraphviZ } from './examples/PgDev_Graphviz/PgDev_GraphviZ.js';
import { PgDev_TS_Slider } from './examples/PgDev_TS_Slider/PgDev_TS_Slider.js';
import { PgDev_ErrorBoundary } from './examples/PgDev_ErrorBoundary/index.js';
import { PgDev_CssTransitions } from './examples/PgDev_CssTransitions/index.js';
import { PgDev_Notifications } from './examples/PgDev_Notifications/index.js';
import { PgDev_GeneralTesting } from './examples/PgDev_GeneralTesting/index.js';
import { PgDev_FHIRConsole } from './examples/PgDev_FHIR/PgDev_FHIR.js';
import { PgDev_ThemeTest } from './examples/PgDev_ThemeTest/ThemeTest.js';
import { PgDev_DragAndDrop } from './examples/PgDev_DragAndDrop/PgDev_DragAndDropTest.js';
import { PgDev_Palette } from './examples/PgDev_Palette/PgDev_Palette.js';
import { PgDev_DialogIndexing } from './examples/PgDev_DialogIndexing/index.js';
import { PgDev_DraggableTable } from './examples/PgDev_DraggableTable/PgDev_DraggableTable.js';
import { PgDev_DropDownTest } from './examples/PgDev_DropDownTest/PgDev_DropDownTest.js';
import { PgDev_InputsTest } from './examples/PgDev_InputsTest/index.js';
import { PgDev_TS_Table } from './examples/PgDev_TS_Table/PgDev_TS_Table.js';
import { Playground_Tree_Data } from './examples/Example_Tree_Data.js';
import { PgDev_VirtualizedElements } from './examples/PgDev_VirtualizedElements/PgDev_VirtualizedElements.js';
import { PgDev_PopUpTest } from './examples/PgDev_PopUpTests/PgDev_PopUpTest.js';
import { PgDev_ProgressBar } from './examples/PgDev_ProgressBar/PgDev_ProgressBar.js';
import { PgDev_WindowMessenger, PgDev_WindowMessengerFrame } from './examples/PgDev_WindowMessenger/PgDev_WindowMessenger.js';
import { ATSGroup_ThunderstormComponents } from '@nu-art/thunderstorm-frontend/index';
import { PgDev_ReadMore } from './examples/PgDev_ReadMore.js';
import { PgDev_PrintableDP } from './examples/PgDev_PrintableDP.js';
import { PgDev_DPManager } from './examples/PgDev_DPManager.js';
import { ATS_FHIRQueryResources } from '@app/advisor-content-frontend/ats/ATS_FHIRQueryResources/ATS_FHIRQueryResources';
import { ATS_NLPModelEditor } from '@app/advisor-content-frontend/_entity/nlp-model/ATS_NLPModelEditor/ATS_NLPModelEditor';
import { ATS_ColorGroupEditor } from '@app/dp-frontend/ats';
import { ATS_JsonToObject } from '@nu-art/json-to-object-renderer/ATS_JsonToObject/index';
import { ATS_HCSv2 } from '@app/hcs-frontend/ats';
import { ATS_KM2InputDesign } from '@app/styles/frontend/ats/ATS_KM2InputDesign/ATS_KM2InputDesign';
import { ATS_AppState } from '@nu-art/app-state/frontend/_ats/ATS_AppState/ATS_AppState';
import { ATS_FloatingWindows } from '@nu-art/floating-windows/ats';
import { ATS_Toasting } from '@nu-art/toasting/app-tools';
import { PgDev_Preview } from './examples/PgDev_Preview/PgDev_Preview.js';
export const playgroundScreens = [
    ...ATSGroup_ThunderstormComponents,
    ATS_FHIRQueryResources.Screen,
    ATS_NLPModelEditor.Screen,
    ATS_ColorGroupEditor.Screen,
    ATS_JsonToObject.screen,
    ATS_HCSv2.screen,
    ATS_KM2InputDesign,
    ATS_AppState,
    ATS_FloatingWindows,
    ATS_Toasting,
    PgDev_ReadMore,
    PgDev_WindowMessenger,
    PgDev_ProgressBar,
    PgDev_PopUpTest,
    PgDev_SpellCheckTest,
    PgDev_Dialog,
    PgDev_GraphviZ,
    PgDev_TS_Slider,
    PgDev_ErrorBoundary,
    PgDev_CssTransitions,
    PgDev_Notifications,
    PgDev_GeneralTesting,
    PgDev_FHIRConsole,
    PgDev_ThemeTest,
    PgDev_DragAndDrop,
    PgDev_Palette,
    PgDev_DialogIndexing,
    PgDev_DraggableTable,
    PgDev_DropDownTest,
    PgDev_InputsTest,
    PgDev_TS_Table,
    Playground_Tree_Data,
    PgDev_VirtualizedElements,
    PgDev_WindowMessengerFrame,
    PgDev_PrintableDP,
    PgDev_DPManager,
    PgDev_Preview,
];
